export default {
  namespaced: true,
  state: {
    businessLicenseUrl: ''
  },
  mutations: {
    setBusinessLicenseUrl(state, businessLicenseUrl) {
      state.businessLicenseUrl = businessLicenseUrl;
    }
  }
};
